import Vue from 'vue';
import ImageObserver from '@app/global/ImageIntersectionObserver';
Vue.directive('lazy', {
    bind: function (el, binding) {
        if (binding.modifiers.blur) {
            el.style.filter = 'blur(10px)';
            el.style.transition = 'all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1)';
        }
    },
    inserted: function (el) {
        Vue.nextTick(function () {
            ImageObserver.observe(el);
        });
    },
});
